/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMProductViewPayload } from '@/data/types/GTM';
import { getAttributeValueByIdentifier } from '@/utils/productAttributes';

export const getGTMProductViewEventData = async (payload: GTMProductViewPayload) => {
	const { product, listerFlag, storeName } = payload;
	const { partNumber, name, productPrice, manufacturer, stockAvailable } = product;
	const currency = productPrice?.currency ?? '';
	const marketplaceStore = storeName;
	const affiliation = undefined; // This should be the Seller Organization name
	const value = productPrice?.offer;
	// Extra attribute data  for GTM 
	const ean13:string = getAttributeValueByIdentifier(product?.attributes, "Ean13");
	const yearPublished:string = getAttributeValueByIdentifier(product?.attributes, "OriginalYearOfPublication");
	const colour:string = getAttributeValueByIdentifier(product?.attributes, "Color");
	const brandAndSerie:string = getAttributeValueByIdentifier(product?.attributes, "BrandAndSerie");
	const materials:string = getAttributeValueByIdentifier(product?.attributes, "Material");

	const products = [
		{
			id: partNumber,
			name,
			price: productPrice?.offer,
			list: listerFlag ? 'Category' : 'Search Results',
			currency: productPrice.currency,
			brand: manufacturer,
			affiliation,
			mpn:ean13,
			productionDate:yearPublished,
			color:colour,
			category:brandAndSerie,
			material:materials,
			stock:stockAvailable,
			// Do we need these parameters?
			position: undefined,
		},
	];
	return { products, currencyCode: currency, marketplaceStore, value };
};
